import {
  followStateOptions,
  overDueLevelOptions,
  customerTypeOptions,
  receivableStateOptions,
  getStateOptions,
  payMethodOptions,
} from './constants'
import { operateMaxShowLength } from '@/store/dict/config'

/**
 * 逾期单详情
 */
const config = function () {
  return {
    // 跟进记录 column
    followColumns: [
      {
        name: 'gmtCreate',
        columnProps: {
          label: '跟进时间',
          prop: 'gmtCreate',
          width: '200px',
        },
      },
      {
        name: 'createUser',
        columnProps: {
          label: '跟进人',
          prop: 'createUser',
        },
      },
      {
        name: 'followDesc',
        columnProps: {
          label: '跟进记录',
          prop: 'followDesc',
          minWidth: '300px',
        },
      },
    ],
    // 逾期收款记录 column
    overdueColumns: [
      {
        name: 'id',
        columnProps: {
          label: '收款ID',
          prop: 'id',
        },
      },
      {
        name: 'amount',
        columnProps: {
          label: '收款金额（元）',
          prop: 'amount',
          width: '120px',
        },
      },
      {
        name: 'receivableAccountName',
        columnProps: {
          label: '收款账户',
          prop: 'receivableAccountName',
        },
      },
      {
        name: 'payMethod',
        columnProps: {
          label: '收款方类型',
          prop: 'payMethod',
          width: '120px',
        },
        render: ({ row }) => {
          const findItem = payMethodOptions.find((item) => item.value === row.payMethod)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'customerName',
        columnProps: {
          label: '客户付款账户',
          prop: 'customerName',
          width: '120px',
        },
      },
      {
        name: 'state',
        columnProps: {
          label: '收款状态',
          prop: 'state',
        },
        render: ({ row }) => {
          const findItem = getStateOptions.find((item) => item.value === row.state)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'gmtCreate',
        columnProps: {
          label: '创建时间',
          prop: 'gmtCreate',
          width: '200px',
        },
      },
      {
        name: 'completeTime',
        columnProps: {
          label: '完成时间',
          prop: 'completeTime',
          width: '200px',
        },
      },
      {
        name: 'discardTime',
        columnProps: {
          label: '作废时间',
          prop: 'discardTime',
          width: '200px',
        },
      },
      {
        name: 'discardDesc',
        columnProps: {
          label: '作废原因',
          prop: 'discardDesc',
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
          width: 240,
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const btns = [
            { name: 'detail', label: '详情', action: () => this.detailHandle(row) },
          ]
          // 收款状态是进行中 有 撤回操作
          if (row.state === 0) {
            btns.push(
              { name: 'backout', label: '撤回', action: () => this.backoutHandle(row) },
            )
          }
          return btns
        },
        type: 'operate',
      },
    ],
    // 详情信息 column
    baseInfoColumns: [
      {
        key: 'receivableId',
        name: '应收ID',
      },
      {
        key: 'customerName',
        name: '客户姓名',
      },
      {
        key: 'customerType',
        name: '客户来源',
        getValue: (infoData) => {
          const findItem = customerTypeOptions.find((item) => item.value === infoData.customerType)
          return (findItem && findItem.label) || '--'
        },
      },
      {
        key: 'idCardNo',
        name: '身份证号码',
      },
      {
        key: 'customerTel',
        name: '电话',
      },
      {
        key: 'plateNo',
        name: '车牌号',
      },
      {
        key: 'receivableAmount',
        name: '应交租金（当前）',
        getValue: (infoData) => {
          return (infoData.receivableAmount !== null && infoData.receivableAmount !== '') ? infoData.receivableAmount : '--'
        },
      },
      {
        key: 'receivedAmount',
        name: '实收租金（当前）',
        getValue: (infoData) => {
          return (infoData.receivedAmount !== null && infoData.receivedAmount !== '') ? infoData.receivedAmount : '--'
        },
      },
      {
        key: 'remainAmount',
        name: '剩余应收金额',
        getValue: (infoData) => {
          return (infoData.remainAmount !== null && infoData.remainAmount !== '') ? infoData.remainAmount : '--'
        },
      },
      {
        key: 'overDueLevel',
        name: '逾期阶段',
        getValue: (infoData) => {
          const findItem = overDueLevelOptions.find((item) => item.value === infoData.overDueLevel)
          return (findItem && findItem.label) || '--'
        },
      },
      {
        key: 'dueDate',
        name: '应收日期',
      },
      {
        key: 'overDueDay',
        name: '逾期天数',
        getValue: (infoData) => {
          return (infoData.overDueDay !== null && infoData.overDueDay !== '') ? infoData.overDueDay : '--'
        },
      },
      {
        key: 'receivableState',
        name: '还款状态',
        getValue: (infoData) => {
          const findItem = receivableStateOptions.find((item) => item.value === infoData.receivableState)
          return (findItem && findItem.label) || '--'
        },
      },
      {
        key: 'followState',
        name: '跟进状态',
        getValue: (infoData) => {
          const findItem = followStateOptions.find((item) => item.value === infoData.followState)
          return (findItem && findItem.label) || '--'
        },
      },
      {
        key: 'followNumber',
        name: '跟进次数',
        getValue: (infoData) => {
          return (infoData.followNumber !== null && infoData.followNumber !== '') ? infoData.followNumber : '--'
        },
      },
    ],
  }
}

export default config
